import React from "react";
import "../css/Location.css";
import map from "../map.png";
import Nav from "./Nav";
import title from "./title.png";
import Banner from "./Banner";
import NearMeIcon from '@material-ui/icons/NearMe';
import gmap from "./images/gmap.png"
function Location() {
  return (
    <div>
       <Nav/>

      <div id="loc-div">
       
          <div id="location-grid">
          <div id="address">
            <center>
              <img src={map} id="map" />
              <h4>Residence Address:</h4>
              <p>Pirtala Agarpara, Deben Sen Road</p>
              <p>North 24 Paraganas</p>
              <p>Kolkata- 700109</p>
            </center>
          </div>
          
          <div id="map-button">
          <center>
          <a href="https://www.google.com/maps/dir//Dr.+Indrani+Datta+(Child+Specialist),+Deben+Sen+Road,+Tara+Pukur+South,+Agarpara,+Kolkata,+West+Bengal+700109/@22.683562,88.386973,14z/data=!4m9!4m8!1m0!1m5!1m1!1s0x39f89dd0497b6691:0xdd2cbcd7e8f8463a!2m2!1d88.3870003!2d22.6835582!3e0?hl=en" target="_blank"><button id="direction-btn"><img src={gmap} width="20%"/>Get Directions</button></a>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14724.803791546059!2d88.3869726!3d22.6835622!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xdd2cbcd7e8f8463a!2sDr%20Indrani%20Dutta!5e0!3m2!1sen!2sin!4v1641503079040!5m2!1sen!2sin"
              height="300"
            ></iframe>
          </center>
          </div>
          </div>
        </div>
     
    </div>
  );
}

export default Location;
